import React, { useEffect, useRef } from "react"
import { Helmet } from "react-helmet";

const EmbeddedHTML = ({ id, scripts, minHeight, html, _key }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const nodeRef = wrapperRef.current;

    if (html) {
      const fragmentHTML = document.createRange().createContextualFragment(html)
      nodeRef?.appendChild(fragmentHTML)
    }
  });

  const Scripts = () => (
    <Helmet>
      {
        scripts && 
        scripts.map((script, index) => (
          <script
            id={`${_key}-${index}`}
            src={script}
          ></script>
        ))
      }
    </Helmet>
  )

  return (
    <>
      <Scripts />
      <div id={id} ref={wrapperRef} className="w-full" style={{ minHeight }} />
    </>
  )
}

export default EmbeddedHTML
